<template>
  <v-menu
    v-if="header.text"
    v-model="menuOpen"
    :close-on-content-click="false"
    :close-on-click="true"
    nudge-bottom="14"
    nudge-left="12"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-hover
        v-slot="{ hover }"
      >
        <span
          class="sn-table-column-header"
          v-on="on"
        >
          {{ header.text }}
          <v-icon
            color="$snBrand03"
          >
            {{ filterIcon }}
          </v-icon>
          <v-icon
            :color="(hover || menuOpen) ? '$snPrimary03' : 'transparent'"
          >
            {{ headerIcon }}
          </v-icon>
        </span>
      </v-hover>
    </template>

    <sn-table-filter-menu
      :header="header"
      :active-filters="activeFilters"
      :active-sort="activeSort"
      @change="applyChanges"
    />
  </v-menu>
</template>

<script>

import SnTableFilterMenu from './snTableFilterMenu'
import snTableFilterMixin from './snTableFilterMixin'

export default {
  name: 'SnTableColumnHeader',
  components: {
    SnTableFilterMenu
  },
  mixins: [snTableFilterMixin],
  data () {
    return {
      menuOpen: false
    }
  },
  computed: {
    filterIcon () {
      return this.hasFilter ? '$snFilters2' : ''
    },
    headerIcon () {
      return this.menuOpen ? '$snChevronUp' : '$snChevronDown'
    }
  },
  methods: {
    applyChanges (changes) {
      this.menuOpen = false
      this.$emit('change', changes)
    }
  }
}

</script>
<style scoped>
.sn-table-column-header {
  min-height: 24px;
}
</style>
